export const MIDDLEWARE_TO_EDGE_IS_SLOW = 1000;
export const HUGINN_LOAD_IS_SLOW = 1000;
export const LWR_IS_SLOW = 5_000;
export const LWR_IS_STALLED = 20_000;
